<template lang="pug">
  .product-container
    .product-header
      .product-title
        p iMedia Tracker - 营销活动管理平台
      .product-desc
        p {{ $t('iMedia Tracker帮助企业整合所有营销资产进行数字化，并且建立营销效果标准。') }}
        p {{ $t('某出行集团借助iMedia Tracker管理所有线上线下渠道的媒介排期素材及跨渠道投放数据管理。') }}
      el-button.product-link(
        @click="onApplyAccount"
      ) {{ $t('申请Demo账号') }}
      .product-img
        img(
          src="@/assets/i_media_tracker-1.png"
        )
    .product-content-container
      .product-content-item
        img(
          src="@/assets/i_media_tracker-2.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('营销资产管理') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('排期智能上传') }}
          .desc {{ $t('用户只需在新建广告活动时，一键导入媒介排期，系统便会自动识别读取所有排期数据，并且支持用户在线编辑已上传排期。一旦广告活动投放完毕，用户可以导入效果数据，从而使得所有排期中的计划数据和实际效果数据进行有效对比与分析。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('营销物料存储') }}
          .desc {{ $t('每一波活动对应的营销物料都可以通过批量上传，存储到对应广告活动中，支持在线预览及下载。企业既不用担心回溯任何历史活动时使用了哪些物料，也不用担心因为员工变更导致交接遗漏。') }}
      .product-content-item
        .product-content-desc.product-content-desc__mr
          .desc-title {{ $t('数据多维分析') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('所有数据可追踪') }}
          .desc {{ $t('无论是哪一年的数据，哪个渠道的数据，哪一级组织架构的数据，媒介排期数据亦或是实际执行数据，均可在该模块实时查询，告别数据碎片化。') }}

          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('多维度交叉分析') }}
          .desc {{ $t('用户可以选择企业内部组织架构层级下的10个维度及15项指标，自由组合，高效查询，数据类型支持计划值+实际值，数据粒度支持日/月/周，同时支持在线分析生成图表及导出报告自由编辑。') }}
        img(
          src="@/assets/i_media_tracker-3.png"
          )
      .product-content-item
        img(
          src="@/assets/i_media_tracker-4.png"
        )
        .product-content-desc.product-content-desc__ml
          .desc-title {{ $t('权限灵活配置') }}
          .desc-subTitle
            img(
              src="@/assets/libra-icon.png"
            )
            span {{ $t('丰富全面的权限') }}
          .desc {{ $t('管理员可根据用户的事业群、事业线、区域、条线自由配置相关权限，增删改查逐一配置，还可以专门设定供应商类型权限，同时无论哪类用户均可提供用户邮箱、电话等常规信息。') }}
    section#clients-say
      div.clients-say__content
        img(
          alt="what our clients say"
          src="@/assets/clients-say-logo.png"
        )
        div
          .client-name 某出行集团市场总监
          ul.clients-say__case__content
            li.active
              p {{ $t('通过使用iMedia Tracker，我们可以快速查询相关营销活动数据，拉取分析报告，评估营销投资回报率，无需再为某个事业群事业线、某个营销渠道、某波Campaign的历史数据犯愁，丰富的数据维度及粒度有助于我们深入分析集团内任何营销数据与花费数据。') }}
    contact
</template>

<script>
import PageFooter from '@/components/PageFooter'
import Contact from '@/components/Contact'
export default {
  components: {
    PageFooter,
    Contact
  },
  methods: {
    onApplyAccount () {
      this.$router.push('/contact?redirectUrl=/product/i_media_tracker&buttonName=申请Demo账号')
    }
  }
}
</script>
